import React, { useState, useEffect,useContext } from "react";
import { Row, Col} from "react-bootstrap";
import CustomMultiSelect from 'components/MultiSelect/MultiSelect';
import { FetchAPI } from '../../api/fetch';
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import Cookies from 'universal-cookie';
import { WizardDataContext } from "context/WizardDataContext";
const cookies = new Cookies();

function Step3(props) {
  const {setHasError} = props;
  let [optionValue, setoptionValue] = useState(props.block.options);
  const [wizardData, setWizardData] = useContext(WizardDataContext);
  
  useEffect(() => {
    try {
      (async () => {
        if(props.futurename === 'Role'){
          // let getURL = props.dropDwnApi;
          // const getdrpdwnresponse = await FetchAPI(getURL);
          const getdrpdwnresponseJson = wizardData.productsView
          setoptionValue(getdrpdwnresponseJson.data.users);
        }
      })()
    } catch(error){
      setHasError({
        error: true,
        message: error
       })
    }
  }, [wizardData]);

  if (props.currentStep !== props.block.step) {
      return null
  } 

  return (
    <div>
      <Row>
        <Col md="4" className="mb-3">
          {/* <label
            htmlFor="defaultFormRegisterNameEx"
            className="grey-text"
          >Select Users</label> */}
          <CustomMultiSelect
            options={optionValue}
            changed = {chk => props.multiselection(chk)}
            selectChildValue={props.selectChildValue}
          />
        </Col>
      </Row>
  </div>
  )
}

export default Step3;
